<template>
  <div class="general-reporting">
    <div class="workload-data">
      <div class="workload-list mt-4 mx-3 pt-4">
        
        <material-card
          color="orange"
          title="Search Registration Reports">
          <div
            v-show="!workloadView"
            class="workload-list">

            <v-expansion-panel>
              <v-expansion-panel-content>
                <template v-slot:header>
                  <div>Filter Search</div>
                </template>

                <v-layout row justify-xl-start class="search-box">
                  <v-flex md3>
                    <v-menu
                        v-model="fromDateModal"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px">
                        <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="from_date"
                            label="Start Date"
                            prepend-icon="event"
                            clearable
                            readonly
                            v-on="on"
                        />
                        </template>
                        <v-date-picker
                        v-model="from_date"
                        @input="fromDateModal = false"/>
                    </v-menu>
                  </v-flex>
                  
                  <v-flex md3>
                    <v-menu
                        v-model="endDateModal"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px">
                        <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="end_date"
                            label="End Date"
                            prepend-icon="event"
                            clearable
                            readonly
                            v-on="on"
                        />
                        </template>
                        <v-date-picker
                        v-model="end_date"
                        @input="endDateModal = false"
                        @change="onDateFilterUpdate"/>
                    </v-menu>
                  </v-flex>
                  
                  <v-spacer />

                  <v-flex md5>
                    <v-btn
                      :loading="newOppRegistration.searching"
                      color="success"
                      @click="filterOppRegRequestData">Search
                    </v-btn>

                    <v-btn
                      :loading="newOppRegistration.inProgress"
                      color="success"
                      @click="downloadAWSextracData">Download
                    </v-btn>

                    <v-btn
                      :loading="newOppRegistration.reportInProgress"
                      color="success"
                      @click="extractAWSReportData">Report
                    </v-btn>
                  </v-flex>

                </v-layout>
              
                <v-layout row justify-sm-start class="search-box">

                  <v-flex md3>
                    <v-text-field
                      v-model.trim="sfdcId"
                      solo
                      placeholder="DXC SFDC OPPORTUNITY ID"/>
                    <v-divider/>
                    <v-text-field
                      v-model.trim="Customer_Name"
                      solo
                      placeholder="CUSTOMER NAME"/>
                    
                  </v-flex>

                  <v-divider light />

                  <v-flex md3>
                    <h4>Choose Region</h4>
                    <v-radio-group v-model="ESRegion">
                      <template v-for="item in filteredRegions">
                        <v-radio
                          :label="item"
                          :value="item"
                          color="orange"/>
                      </template>
                    </v-radio-group>
                  </v-flex>
                  
                  <!-- <v-flex md3>
                    <h4>Choose Status</h4>
                    <v-radio-group v-model="Workload_Status">
                      <template v-for="item in filteredWorkBookStatus">
                        <v-radio
                          :label="item"
                          :value="item"
                          color="orange"/>
                      </template>
                    </v-radio-group>
                  </v-flex> -->

                  <v-flex  
                  xs13
                  sm3
                  md3
                  xl3
                  mx-3>
                  <h4>Choose Status</h4>
                  <v-select
                      v-model="selectedStatus"
                      :items="NewWorkloadStatus"
                      label="Filter by Status"
                      @change="changedStatus"
                      multiple
                      chips
                      solo
                      attach/>
                  <h4>Choose Initiative</h4>
                    <v-container fluid>
                      <v-checkbox color="orange" hide-details v-model="selectedGlacierInitiative" label="Glacier Campaign" value="Glacier"></v-checkbox>
                      <v-checkbox color="orange" hide-details v-model="selectedGlobalInitiative" label="Global Register Initiative" value="Global"></v-checkbox>
                    </v-container>
                  </v-flex>

                  <v-flex md3>
                    <h4>Choose Form</h4>
                    <v-radio-group v-model="ViewType">
                      <template v-for="item in filteredViewTypeList">
                        <v-radio
                          :label="item"
                          :value="item"
                          color="orange"/>
                      </template>
                    </v-radio-group>
                  </v-flex>
               
                </v-layout>

              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-divider/>

            <v-progress-linear
              v-slot:progress
              v-if="loadingRequest"
              color="orange"
              indeterminate/>

            <v-data-table
              :headers="filteredWorkloadHeaders"
              :items="workloadList"
              :pagination.sync="pagination"
              :loading="newOppRegistration.searching"
              item-key="Project_Id"
              disable-initial-sort
            >
              <template v-slot:no-data>
                <v-alert
                  v-if="newOppRegistration.withError"
                  :value="true"
                  color="#000"
                  icon="warning">
                  No Opportunity Registration request found! Please check Filters and try again.
                </v-alert>
              </template>
              <template
                slot="headerCell"
                slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-success text-md-left text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <tr v-if="ViewType === 'Default'">
                  <td>
                    <Can
                      i="manage"
                      a="oppreg">
                      <a
                        href="#"
                        @click="onWorkloadView(props.item)">{{ props.item.Project_Id }}</a>
                    </Can>
                  </td>
                  <td>{{ props.item.OppReg_Id }}</td>
                  <td>{{ props.item.AWS_ACE_ID }}</td>
                  <!-- <td>{{ props.item.Opportunity_Number }}</td> -->
                  <td>
                    <a
                      href="#"
                      @click="onWorkloadView(props.item)">{{ props.item.SFDC_Oppty_Name }}</a>
                  </td>
                  <td>{{ props.item.Workload_Title }}</td>
                  <td>{{ props.item.Workload_Status }}</td>
                  <td>{{ props.item.Workload_type }}</td>
                  <td>{{ props.item.Campaign_Name }}</td>
                  <td>{{ props.item.Requestor_Email }}</td>
                  <td>{{ props.item.Customer_Name }}</td>
                  <td>{{ props.item.Customer_Region }}</td>
                  <td>{{ props.item.Country }}</td>
                  <td>{{ props.item.SignDate }}</td>
                  <td>{{ props.item.Q4 }}</td>
                  <td>{{ props.item.Q5 }}</td>
                  <td>{{ props.item.Q6 }}</td>
                  <td>{{ props.item.Attested_By_Email }}</td>
                  <td>{{ props.item.Date_Created }}</td>
                </tr>

                <!-- SIMPLE -->
                <tr v-if="ViewType === 'Simple'">
                  <td>
                    <Can
                      i="manage"
                      a="oppreg">
                      <a
                        href="#"
                        @click="onWorkloadView(props.item)">{{ props.item.Project_Id }}</a>
                    </Can>
                  </td>
                  <td>{{ props.item.OppReg_Id }}</td>
                  <td>{{ props.item.AWS_ACE_ID }}</td>
                  <!-- <td>{{ props.item.Opportunity_Number }}</td> -->
                  <td>{{ props.item.Customer_Name }}</td>
                  <td>{{ props.item.Customer_Region }}</td>
                  <td>
                    <Can
                      i="manage"
                      a="oppreg">
                      <a
                        href="#"
                        @click="onWorkloadView(props.item)">{{ props.item.SFDC_Oppty_Name }}</a>
                    </Can>
                  </td>
                  <td>{{ props.item.Workload_Title }}</td>
                  <td>{{ props.item.Workload_Status }}</td>
                  <td>{{ props.item.Workload_type }}</td>
                  <td>{{ props.item.Campaign_Name }}</td>
                  <td>{{ props.item.Requestor_Email }}</td>
                  <td>{{ props.item.SignDate }}</td>
                  <td>{{ props.item.Q5 }}</td>
                  <td>{{ props.item.Q6 }}</td>
                  <td>{{ props.item.Attested_By_Email }}</td>
                  <td>{{ props.item.Date_Created }}</td>
                </tr>

                <!-- EXPANDED -->
                <tr v-if="ViewType === 'Expanded'">
                  <td>
                    <Can
                      i="manage"
                      a="oppreg">
                      <a
                        href="#"
                        @click="onWorkloadView(props.item)">{{ props.item.Project_Id }}</a>
                    </Can>
                  </td>
                  <td>{{ props.item.OppReg_Id }}</td>
                  <td>{{ props.item.AWS_ACE_ID }}</td>
                  <!-- <td>{{ props.item.Opportunity_Number }}</td> -->
                  <td>{{ props.item.Customer_Name }}</td>
                  <td>{{ props.item.Workload_Title }}</td>
                  <td>{{ props.item.Customer_Region }}</td>
                  <td>{{ props.item.SignDate }}</td>
                  <td>
                    <Can
                      i="manage"
                      a="oppreg">
                      <a
                        href="#"
                        @click="onWorkloadView(props.item)">{{ props.item.SFDC_Oppty_Name }}</a>
                    </Can>
                  </td>
                  <td>{{ props.item.Q4 }}</td>
                  <td>{{ props.item.Workload_Status }}</td>
                  <td>{{ props.item.Workload_type }}</td>
                  <td>{{ props.item.Campaign_Name }}</td>
                  <td>{{ props.item.Requestor_Email }}</td>
                  <td>{{ props.item.Q5 }}</td>
                  <td>{{ props.item.Q6 }}</td>
                  <td>{{ props.item.Attested_By_Email }}</td>
                  <td>{{ props.item.Date_Created }}</td>
                </tr>
              </template>
            </v-data-table>

          </div>

          <div
            v-show="workloadView"
            class="workload-detail-view">
            <v-layout row>
              <v-flex>
                <v-btn @click="workloadView = false">Go back to list</v-btn>
              </v-flex>
              <v-flex style="text-align: right">
                <v-btn @click="showChangelogs(workloadData)"><v-icon
                  small
                  title="Changelogs"
                  class="mr-2"
                  color="primary"
                  flat>history</v-icon>View Changelogs</v-btn>
              </v-flex>
            </v-layout>
            <table>
              <tr>
                <th>Field</th>
                <th>Value</th>
              </tr>
              <tr v-for="(value, name) in workloadViewData">
                <td>{{ name }}</td>
                <td>{{ value }}</td>
              </tr>
            </table>
          </div>

        </material-card>
      </div>
    </div>
  </div>
</template>
<script>

import { mapMutations, mapState, mapActions } from 'vuex'
import { getAwsExtractData, getAwsReportData } from '@/utils/helper'

export default {
  $_veeValidate: { validator: 'new' },
  data () {
    return {
      from_date: '',
      end_date: '',
      fromDateModal: false,
      endDateModal: false,
      onDateFilterUpdate: false,
      sfdcId: '',
      Customer_Name: '',
      ESRegion: '',
      selectedGlacierInitiative: '',
      selectedGlobalInitiative: '',
      Workload_Status: '',
      ViewType: 'Default',
      regions: ['All Region', 'Americas', 'UKI', 'Europe', 'APJ-MEA', 'Luxoft'],
      initiatives: ['Glacier Campaign', 'Global Register Initiative'],
      // WorkBookStatus: ['All', 'Incomplete', 'Submitted by User', 'Ready for submission'],
      viewTypeList: ['Default', 'Simple', 'Expanded'],
      pagination: {
        descending: true,
        sortBy: 'Date_Created',
        page: 1,
        rowsPerPage: 10,
        totalItems: 0
      },
      workloadView: false,
      workloadData: {},
      workloadFields: [
        'Registration_Id',
        'SFDC_Id',
        'SignDate',
        'Oppreg_Req_Date',
        'Workload_Status',
        'SFDC_Oppty_Name',
        'Customer_Name',
        'Customer_Region',
        'Customer_Address',
        'Customer_City',
        'Customer_State',
        'Customer_PC',
        'Customer_URL',
        'Contact_FullName',
        'Contact_Phone',
        'RFI_RFP',
        'Workload_Title',
        'Workload_type',
        'WL_Q1A',
        'WL_Q2A',
        'WL_Q3A',
        'WL_Q4A',
        'WL_Q5A',
        'WL_Q6A',
        'Attested_By',
        'DXC_Services',
        'WL_Q7A',
        'WL_Q8A',
        'WL_Q9A',
        'WL_Q10A',
        'Projected_Monthly_Spend',
        'Scope_of_Work'
      ],
      NewWorkloadStatus: [
        'All',
        'Ready for Submission',
        'Submitted by User',
        'AWS Reg Accepted',
        'Incomplete/Under Review',
        'Submitted to AWS',
        'LEGACY - Approved - Tier 1 23% - PPA',
        'LEGACY - Approved - Tier 1 23% - PPA SaaS',
        'LEGACY - Approved - Tier 3 12%',
        'LEGACY - Approved - Tier 2 - Custom EDP',
        'LEGACY - Internal - Tier 1 23% - PPA',
        'Disqualified - AWS forecast conflict',
        'Shareshift',
        'Disqualified - Incomplete',
        'Disqualified - No AWS scope',
        'OppReg Closed',
      ],
      selectedStatus: null
    }
  },
  mounted () {
    this.$store.dispatch('admin/oppregAdmin/getOppRegRequestData', {})
    this.from_date =  moment().subtract(30, 'days').format('YYYY-MM-DD')
    this.end_date = moment().format('YYYY-MM-DD')

  },
  computed: {
    workloadViewData () {
      let viewData = {}
      if (Object.entries(this.workloadData).length !== 0) {
        for (var key in this.workloadData) {
          if (this.workloadFields.includes(key)) {
            viewData[key] = this.workloadData[key]
          }
        }
      }
      return viewData
    },
    ...mapState('admin/oppregAdmin', ['OppRegMasterHeaders', 'OppRegRequestHeaders', 'OppRegExpandedHeaders', 'workloadList','workloadLists1', 'newOppRegistration', 'loadingRequest']),
    filteredWorkloadHeaders () {
      let simpleHeader = ['Project_Id', 'OppReg_Id', 'AWS_ACE_ID', 'Customer_Name', 'SFDC_Oppty_Name', 'Workload_Title', 'Workload_Status', 'Workload_type', 'Campaign_Name', 'Requestor_Email', 'Customer_Region', 'SignDate', 'Public_Sector', 'Advisory_Services', 'Attestation', 'Date_Created']
      let expandedHeader = ['Project_Id', 'OppReg_Id', 'AWS_ACE_ID', 'Customer_Name', 'Workload_Title', 'Customer_Region', 'SignDate', 'SFDC_Oppty_Name', 'Projected_Monthly_Spend','Scope_of_Work', 'Workload_Status', 'Workload_type', 'Campaign_Name', 'Requestor_Email','Public_Sector', 'Advisory_Services', 'Attestation', 'Date_Created']
      let defaultHeader = ['Project_Id', 'OppReg_Id', 'AWS_ACE_ID', 'SFDC_Oppty_Name', 'Workload_Title', 'Workload_Status', 'Workload_type',  'Campaign_Name', 'Requestor_Email', 'Customer_Name', 'Customer_Region', 'Country', 'Closing_Date', 'AWS_Charge', 'Public_Sector', 'Advisory_Services', 'Attestation', 'Date_Created']
      
      if (this.ViewType === 'Simple') {
        return this.OppRegRequestHeaders.filter(header => simpleHeader.includes(header.value))
      } else if (this.ViewType === 'Expanded') {
        return this.OppRegExpandedHeaders.filter(header => expandedHeader.includes(header.value))
      } else if (this.ViewType === 'Default') {
        return this.OppRegMasterHeaders.filter(header => defaultHeader.includes(header.value))
      }
    },
    filteredRegions () {
      return this.regions
    },
    filteredWorkBookStatus () {
      return this.WorkBookStatus
    },
    filteredViewTypeList () {
      return this.viewTypeList
    },
    filteredWorkloadList () {
      return this.workloadList
    },
    filteredWorkloadList () {
      return this.workloadList1
    },
    
    awsExtractData () {
      if (this.workloadList.length) {
        console.log('------ this.workloadList -------')
        console.log(this.workloadList)
        console.log('--------------------------------')
        return getAwsExtractData(this.workloadList)
      }
    },

    awsReportData (){
      if (this.workloadLists1.length) {
        console.log('------ mytest -------')
        console.log(this.workloadLists1)
        console.log('--------------------------------')
        return getAwsReportData(this.workloadLists1)
      }
    }

  },
  methods: {
    ...mapMutations({
      clearWorkloadForm: 'admin/oppregAdmin/clearWorkloadForm',
      showNewWorkload: 'admin/oppregAdmin/showNewWorkload',
      setWorkloadData: 'admin/oppregAdmin/setWorkloadData',
      showEditWorkload: 'admin/oppregAdmin/showEditWorkload',
      hideWorkload: 'admin/oppregAdmin/hideWorkload',
      resetNewOppRegistration: 'admin/oppregAdmin/resetNewOppRegistration',
      setValidatedRegistration: 'admin/oppregAdmin/setRegistrationIdValidation',
      setOpportunityFound: 'admin/oppregAdmin/setOpportunityFound',
      delWorkloadFields: 'admin/oppregAdmin/delWorkloadFields'

    }),
    onSearchOpportunity () {
      this.$store.dispatch('admin/oppregAdmin/getWorkloadsByOppId', this.searchId)
    },
    onWorkloadView (data) {
      this.workloadView = true
      this.workloadData = data
    },
    filterOppRegRequestData () {
      this.resetNewOppRegistration()
      const selectedStatus = this.selectedStatus ? (this.selectedStatus.includes('All') ? 'All' :this.selectedStatus.toString()) : '';
      console.log('selectedStatus>>>',selectedStatus)
      let params = {
        sfdcId: this.sfdcId,
        Customer_Name: this.Customer_Name,
        ESRegion: (this.ESRegion !== 'All Region') ? this.ESRegion : '',
        // Workload_Status: (this.Workload_Status !== 'All') ? this.Workload_Status : '',
        Workload_Status: selectedStatus,
        from_date: this.from_date,
        to_date: this.end_date
      }
      if (this.selectedGlobalInitiative) {
        params['Global_Registered'] = 'Yes'
      }
      if (this.selectedGlacierInitiative) {
        params['Campaign_Name'] = 'Glacier'
      }
      this.$store.dispatch('admin/oppregAdmin/getOppRegRequestData', params)
    },
    showChangelogs (workload) {
      this.$store.dispatch('showLogRecords', workload.Project_Id)
    },
    downloadAWSextracData(){
      this.$store.dispatch('admin/oppregAdmin/downloadOppRegRequestData', {action: "download"})
    },
    extractAWSReportData(){
      this.$store.dispatch('admin/oppregAdmin/reportOppRegRequestData', {action: "report"})
    },
    changedStatus(event) {
      console.log('selectedStatus', event)
      if (event.includes('All')) {
        this.selectedStatus = ['All']
      } else {
        this.selectedStatus = event;
      }
    }
    
  }
}
</script>

<style lang="scss" scoped>
.general-reporting {

  .search-box {
    margin: 0 auto;
    padding-left: 10px;
    font-size: 5px;

    input {
      height: 15px;
    }
    
  }

  .workload-detail-view {
    width: 80%;
    margin: 0 auto;

    table {
      width: 100%;
    }

    td, th {
      border: 1px solid #ddd;
      padding: 8px;
    }

    tr:nth-child(even){background-color: #f2f2f2;}

    tr:hover {background-color: #ddd;}

    th {
      padding-top: 12px;
      padding-bottom: 12px;
      text-align: left;
      background-color: #ffa726;
      color: #fff;
    }

  }
}
</style>
